import React, { useRef, useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Forms } from "../../../Reuseable/Forms";
import { api } from "../../../../Services/api";
import {
  setShowAlert,
  setAllTrackings,
  setMyTrackings,
  setAllPriorityData,
} from "../../../../redux/Tracking/actionCreator";
import { ConfirmationBox } from "../../../Reuseable/ConfimationBox";
import TrackingFormWrap from "./style.js";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useFetch } from "../../../../Hooks/useFetch";
import { key } from "../../../../data/queryKeys";
import { fileToBase64 } from "../../../../Utilities/commonFunctions";
import BarLoader from "react-spinners/ClipLoader";
import moment from "moment";

export const NewTracking = ({
  setTaskview,
  setShowAlertBox,
  setAlertMessage,
  inputFormArr,
}) => {
  console.log("inputFormArr>", inputFormArr);
  /******************************* react functions   *******************/
  const dispatch = useDispatch();
  /*************************** redux var intiaalize *******************/
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );

  const { data: allProjectsRes, refetch: getAllProjects } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allProjects = allProjectsRes?.data?.Items ?? [];

  const allprojectsnew = allProjectsRes?.data?.Items ?? [];

  let allTrackingsList = useSelector((state) => state.Tracking.allTrackings);
  let myTrackingList = useSelector((state) => state.Tracking.myTrackings);

  const user = useSelector((state) => state.Auth.user);
  const authToken = useSelector((state) => state.Auth.authToken);

  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    true,
  );
  let allTaskTypes = allTasksTypesRes?.data ?? [];

  const { refetch: getAllMembers } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );

  /*************************** react state  intiaalize *******************/
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(true);

  const [cancelConfirmationShow, setCancelConfirmationShow] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [fileArr, setFileArr] = useState([]);
  const [tudfileArr, setTudFileArr] = useState([]);
  console.log("tudfileArr", tudfileArr);
  const [fileNameList, setFileNameLIst] = useState([]);
  const [changeInForm, setChangeInForm] = useState(false);
  const [resetEditorValue, setResetEditorValue] = useState(false);
  const [fileSize, setFileSize] = useState("");
  const [formvalue, setFormvalue] = useState({});
  console.log("formvalue32---->", formvalue);
  const [inputvalue, setInputvalue] = useState({});
  console.log(inputvalue, "inputvalue", inputvalue?.deadline);
  const [rawPriorities, setRawPriorities] = useState([]); // ⬅️ store the full response
  const [customPriorityOptions, setCustomPriorityOptions] = useState([]);
  const [matched, setMatched] = useState(null);
  const [matchedProjectNew, setMatchedProject] = useState(null); // New state for matchedProject
  const [holidays, setHolidays] = useState([]);
  const [valuefordeadline, setValuefordeadline] = useState("");
  console.log("holidays-->", holidays);
  console.log(valuefordeadline, "valuefordeadline");
  const priorityList = useSelector((state) => state.Tracking.allPriorityData);
  console.log("priorityList-->", priorityList);
  const clientId = useSelector((state) => state.Auth.user.trackingclientid);

  // Auto-set ETA and deadline when priority is selected

  const menus = useSelector((state) => state.Auth.menuList);

  const editorRef = useRef(null);
  const addNewProject = [{ label: "+ Add New Project", id: "Add New Project" }];
  const isAbleToAddNewProject =
    (menus.find((menu) => menu.name === "Projects")?.access ?? false)
      ? true
      : false;

  /***************************** components  *************************/
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  /************************* conditions *******************/

  let result = [];
  let team_mates = allProjects.find(
    (e) => e.trackingprojectid === formvalue?.id,
  );
  if (team_mates) team_mates = team_mates.teammates;
  if (team_mates) {
    team_mates.forEach((element) => {
      result.push({ label: element.label, id: element.id });
    });
  }

  if (allProjects.length > 0) {
    let result = [];
    allProjects.forEach((element) => {
      result.push({ label: element.label, id: element.trackingprojectid });
    });
    allProjects = result;
  }

  if (allTaskTypes.length > 0) {
    let result = [];
    allTaskTypes.forEach((item) =>
      result.push({ label: item.label, id: item.id }),
    );
  }
  /************************************************/
  const { data: allInputformsRed } = useFetch(
    key.get_all_inputforms,
    "/masterdata/2",
    () => {},
    () => {},
    false,
    false,
  );

  useEffect(() => {
    api
      .get(`/tracking/priority/${trackingClientId}`)
      .then((res) => {
        setRawPriorities(res.data.data);
      })

      .catch(console.error);
  }, [trackingClientId]);

  useEffect(() => {
    api
      .get(`/tracking/holidays/${clientId}`, {
        headers: {
          authorizationtoken: ` ${authToken}`,
        },
      })
      .then((res) => {
        console.log(res, "resres");
        setHolidays(
          res?.data?.data?.map((item) => {
            return moment(item?.holidaydate, "YYYY-MM-DD").format("DD-MM-YYYY");
          }),
        );
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    const selectedProjectLabel = formvalue?.id;

    if (!selectedProjectLabel) {
      setCustomPriorityOptions([]);
      setFormvalue((prev) => ({ ...prev, priority: null }));
      return;
    }
    const proj = rawPriorities?.find(
      (p) => p.trackingprojectid === selectedProjectLabel,
    );
    const opts =
      proj?.prioritydata.map((pd) => ({
        label: pd.priority,
        value: pd.priority,
        days: pd.days,
        hours: pd.hours,
      })) || [];
    setCustomPriorityOptions(opts);
    setFormvalue((prev) => {
      if (!prev.priority) return { ...prev, priority: null };
      const found = opts.find(
        (opt) =>
          opt.value === prev.priority.value ||
          opt.label === prev.priority.label,
      );
      return found ? prev : { ...prev, priority: null };
    });
  }, [rawPriorities, formvalue?.label]);

  // useEffect(() => {
  //   const selectedProjectLabel = formvalue?.label;
  //   const project = rawPriorities?.find(
  //     (p) => p.projectName === selectedProjectLabel
  //   );

  //   if (!project) return;

  //   console.log(project, "projectprojectsx")

  //   const priorityObj = project.prioritydata?.find(
  //     (pd) => pd.priority === formvalue?.priority
  //   );
  //   if (!priorityObj) return;

  //   const hrs = Number(priorityObj.hours);
  //   const etaString = `${hrs} hours`;

  //   const now = new Date();
  //   const deadlineDate = new Date(now.getTime() + hrs * 60 * 60 * 1000);
  //   while (deadlineDate.getDay() === 0 || deadlineDate.getDay() === 6) {
  //     deadlineDate.setDate(
  //       deadlineDate.getDate() + (deadlineDate.getDay() === 6 ? 2 : 1)
  //     );
  //   }
  //   const pad = (n) => n.toString().padStart(2, "0");
  //   const day = pad(deadlineDate.getDate());
  //   const mon = pad(deadlineDate.getMonth() + 1);
  //   const yr = deadlineDate.getFullYear();

  //   let hrs24 = deadlineDate.getHours();
  //   const mins = pad(deadlineDate.getMinutes());
  //   const ampm = hrs24 >= 12 ? "PM" : "AM";
  //   const hrs12 = hrs24 % 12 || 12;
  //   const formattedDeadline = `${day}/${mon}/${yr}, ${pad(hrs12)}:${mins} ${ampm}`;

  //   let startHrs24 = now.getHours();
  //   const startAmpm = startHrs24 >= 12 ? "PM" : "AM";
  //   const startHrs12 = startHrs24 % 12 || 12;
  //   const formattedStartDateTime = `${pad(now.getDate())}/${pad(
  //     now.getMonth() + 1
  //   )}/${now.getFullYear()}, ${pad(startHrs12)}:${pad(
  //     now.getMinutes()
  //   )} ${startAmpm}`;
  //   const formattedEndDateTime = formattedDeadline;
  //   const formattedStartDate = `${pad(now.getDate())}/${pad(
  //     now.getMonth() + 1
  //   )}/${now.getFullYear()}`;

  //   const formattedEndDate = `${pad(deadlineDate.getDate())}/${pad(
  //     deadlineDate.getMonth() + 1
  //   )}/${deadlineDate.getFullYear()}`;

  //   setFormvalue((prev) => ({
  //     ...prev,
  //     eta: etaString,
  //     deadline: formattedDeadline,
  //     startdateandtime: formattedStartDate,
  //     enddateandtime: formattedEndDate,
  //   }));

  // }, [
  //   formvalue?.priority,
  //   formvalue?.label,
  //   rawPriorities,
  //   formvalue,
  //   formvalue?.deadline,
  // ]);

  useEffect(() => {
    console.log("working1");
    // const selectedProjectLabel = formvalue?.label;
    const selectedProjectLabel = formvalue?.id;

    console.log("working2", selectedProjectLabel);

    console.log(rawPriorities, "rawPriorities", formvalue);

    // 1️⃣ Find the matching project object from the array
    const projectObj = rawPriorities?.find(
      (p) =>
        p.trackingprojectid?.trim().toLowerCase() ===
        selectedProjectLabel?.trim().toLowerCase(),
    );
    console.log("working3", projectObj);

    console.log(projectObj, "projectObj");

    if (!projectObj) return;

    // 2️⃣ Extract only the projectdata object from it
    const project = projectObj.projectdata;
    console.log(project, "projectdata object");

    // 3️⃣ Find the selected priority
    console.log("working4", project);
    const priorityObj = projectObj.prioritydata?.find(
      (pd) =>
        // pd.priority?.trim().toLowerCase() ===
        // formvalue?.priority?.trim().toLowerCase(),

        pd.priority?.trim()?.toLowerCase() ===
        inputvalue?.priority?.trim().toLowerCase(),
    );
    console.log("working5", priorityObj);

    if (!priorityObj) return;
    const matchedProject = allprojectsnew.find(
      (p) => p.trackingprojectid === projectObj?.trackingprojectid,
    );
    console.log(projectObj, "working5", allprojectsnew);

    // const matchedProject = projectObj.projectdata; // contains projectdata, prioritydata, etc.
    console.log(matchedProject, "matchedProjectasdasda");
    console.log("working6", matchedProject);

    // 4️⃣ Compute ETA and deadline based on project shift
    const { estimatedEndTime, totalHours } = computeEtaAndDeadlineFromPriority(
      // formvalue?.priority?.trim().toLowerCase(),
      inputvalue?.priority?.toLowerCase(),
      project,
      matchedProject,
    );

    console.log("estimatedEndTimeestimatedEndTime", estimatedEndTime);

    // 5️⃣ Format date & time
    const deadlineDate = new Date(estimatedEndTime);
    const now = new Date();

    const pad = (n) => n.toString().padStart(2, "0");
    const formatAMPM = (date) => {
      const hrs = date.getHours();
      const mins = pad(date.getMinutes());
      const ampm = hrs >= 12 ? "PM" : "AM";
      const hrs12 = hrs % 12 || 12;
      return `${pad(hrs12)}:${mins} ${ampm}`;
    };

    const formattedStartDate = `${pad(now.getDate())}/${pad(
      now.getMonth() + 1,
    )}/${now.getFullYear()}`;
    const formattedEndDate = `${pad(deadlineDate.getDate())}/${pad(
      deadlineDate.getMonth() + 1,
    )}/${deadlineDate.getFullYear()}`;
    console.log(
      formattedEndDate,
      "working8",
      deadlineDate.getDate(),
      deadlineDate.getMonth() + 1,
    );

    const formattedDeadline = `${formattedEndDate}, ${formatAMPM(
      deadlineDate,
    )}`;
    console.log(formattedDeadline, "working88");

    const etaString = `${totalHours} hrs`;

    console.log(formattedDeadline, "working8");
    setValuefordeadline(formattedDeadline);
    console.log(valuefordeadline, "working09");

    // if (formvalue?.deadlineType === "No") {
    setFormvalue((prev) => ({
      ...prev,
      eta: etaString,
      deadline: formattedDeadline,
      startdateandtime: formattedStartDate,
      enddateandtime: formattedEndDate,
    }));
    // }
    console.log(valuefordeadline, "working12");
  }, [formvalue?.priority, formvalue?.label, rawPriorities]);

  useEffect(() => {
    if (formvalue !== undefined && formvalue !== null) {
      setFormLoading(false);
    }
  }, [formvalue]);

  /******************************************************/
  allProjects = allProjects;

  let newInputFormArr = inputFormArr;
  console.log("customPriorityOptions--->", customPriorityOptions);
  console.log("inputvalue--->", inputvalue);
  const getTaskTypeOptions = () => {
    // Handle both inputValue and formValue
    const taskTypeObj = inputvalue?.tasktype || formvalue?.tasktype;
    const taskTypeLabel =
      typeof taskTypeObj === "object" ? taskTypeObj?.label : taskTypeObj;

    const taskType = taskTypeLabel?.toLowerCase?.() || "";

    if (taskType === "bugs" || taskType === "issue" || taskType === "bug") {
      return customPriorityOptions.filter(
        (item) =>
          item.label.toLowerCase() === "blocker1" ||
          item.label.toLowerCase() === "blocker2",
      );
    } else if (
      taskType !== "bugs" ||
      taskType !== "issue" ||
      taskType !== "bug"
    ) {
      return customPriorityOptions.filter(
        (item) =>
          item.label.toLowerCase() !== "blocker1" &&
          item.label.toLowerCase() !== "blocker2",
      );
    }

    return customPriorityOptions;
  };

  const taskTypeOptions = useMemo(
    () => getTaskTypeOptions(),
    [inputvalue?.tasktype],
  );
  console.log("taskTypeOptions--->", taskTypeOptions);
  let filteredInputFormArr =
    newInputFormArr &&
    newInputFormArr?.map((item) => {
      if (item?.name === "project_name") {
        item.options = allProjects;
      }
      if (item?.name === "tasktype") {
        item.options = allTaskTypes;
      }
      if (item?.name === "priority") {
        return { ...item, options: taskTypeOptions };
      }

      if (item?.name === "eta" || item?.name === "deadline") {
        console.log(formvalue[item?.name], "formvalue[item?.name]asd");
        return {
          ...item,
          mandatory: false,
          defaultValue: formvalue[item?.name] ?? "",
          value: formvalue[item?.name] ?? "",
          disable: true,
        };
      }

      if (
        item?.name === "startdateandtime" ||
        item?.name === "enddateandtime"
      ) {
        return {
          ...item,
          mandatory: false,
          defaultValue: formvalue[item?.name] ?? "",
          value: formvalue[item?.name] ?? "",
          disable: false,
        };
      }
      // For all other fields, do not override mandatory
      return { ...item };
    });
  // ), [taskTypeOptions]);
  const sortedInputForms = allInputformsRed?.formStructureData?.sort((a, b) => {
    const aSno = parseFloat(String(a.sno).trim());
    const bSno = parseFloat(String(b.sno).trim());
    return aSno - bSno;
  });
  console.log("filteredInputFormArr121--->", filteredInputFormArr);
  let allAddTaskInputs = sortedInputForms ?? [];

  // Show ETA and Deadline fields as per inputFormArr logic
  let filteredAllAddTaskInputs =
    // useMemo(() => (
    allAddTaskInputs &&
    allAddTaskInputs?.map((item) => {
      if (item?.name === "project_name") {
        item.options = allProjects;
      }
      if (item?.name === "priority") {
        return { ...item, options: taskTypeOptions };
      }
      if (item?.name === "tasktype") {
        item.options = allTaskTypes;
      }
      // Only override mandatory for SLA and Deadline
      if (item?.name === "eta" || item?.name === "deadline") {
        return { ...item, mandatory: false, disable: true }; // Ensure the fields are uneditable
      }
      // For all other fields, do not override mandatory
      return { ...item };
    });
  // ), [taskTypeOptions]);

  // helper inside the component
  const normalizePriorityKey = (p) => {
    if (!p) return "";
    if (typeof p === "string") return p;
    // select components often give { label, value }
    return p.value ?? p.label ?? "";
  };
  console.log(formvalue, "neveaa");

  const findProjectFromForm = (form) => {
    const projectLabel =
      form?.project_name?.label ||
      form?.label ||
      form?.project_name ||
      formvalue?.label;

    // Compare projectLabel with label from allProjects
    // let matchedIstaskapproval = null;
    // const matchedProject = allProjects.find((p) => {
    //   if (p.label === projectLabel) {
    //     matchedIstaskapproval = p.istaskapproval;
    //     return true;
    //   }
    //   return false;
    // });

    // console.log("matchedProject",matchedProject);

    // You can use labelComparison for debugging or logic
    // For now, just return the first match as before
    return (
      rawPriorities?.find((p) => p.projectName === projectLabel) ||
      allProjects.find((p) => p.label === projectLabel) ||
      null
    );
  };

  // function computeEtaAndDeadlineFromPriority(priorityKey, project, matchedProject) {
  //   if (!project || !priorityKey) return { etaString: "", deadlineDate: "" };

  //   const po = project.prioritydata?.find(
  //     (pd) => pd.priority?.trim().toLowerCase() === priorityKey?.trim().toLowerCase()
  //   );
  //   if (!po) return { etaString: "", deadlineDate: "" };

  //   // Parse working window from matchedProject (use local/day-of execution)
  //   const [startHour, startMinute] = parseTimeFromISO(matchedProject?.starttime, 9, 0);
  //   const [endHour, endMinute] = parseTimeFromISO(matchedProject?.endtime, 17, 0);
  //   const startTime = startHour + startMinute / 60;
  //   const endTime = endHour + endMinute / 60;
  //   // If end <= start, fallback to 8 hours window
  //   const workHoursPerDay = (endTime > startTime) ? (endTime - startTime) : 8;

  //   // Compute totalHours properly: days * workHoursPerDay + hours (handles fractional days)
  //   const daysNum = Number(po.days || 0);
  //   const hoursNum = Number(po.hours || 0);
  //   const totalHours = (Number.isNaN(daysNum) ? 0 : daysNum * workHoursPerDay) + (Number.isNaN(hoursNum) ? 0 : hoursNum);
  //   const etaString = `${totalHours} hrs`;

  //   // Start from current local time
  //   let current = new Date();
  //   current.setSeconds(0, 0);

  //   let remainingHours = totalHours;

  //   // helper to set current to next working day's start
  //   const moveToNextWorkingDayStart = () => {
  //     do {
  //       current.setDate(current.getDate() + 1);
  //     } while (current.getDay() === 0 || current.getDay() === 6); // skip Sun(0) & Sat(6)
  //     current.setHours(startHour, startMinute, 0, 0);
  //   };

  //   // If today is weekend -> jump to next working day start
  //   while (current.getDay() === 0 || current.getDay() === 6) moveToNextWorkingDayStart();

  //   // Adjust current to be within today's working window (local)
  //   const currentHourDecimal = current.getHours() + current.getMinutes() / 60;
  //   if (currentHourDecimal < startTime) {
  //     current.setHours(startHour, startMinute, 0, 0);
  //   } else if (currentHourDecimal >= endTime) {
  //     // today's work is over -> start next working day's start
  //     moveToNextWorkingDayStart();
  //   }

  //   // Now consume remainingHours within working windows, skipping weekends
  //   while (remainingHours > 0) {
  //     // end-of-work for current day
  //     const workEndToday = new Date(current);
  //     workEndToday.setHours(endHour, endMinute, 0, 0);

  //     const hoursAvailableToday = (workEndToday - current) / 36e5; // ms -> hours
  //     const hoursToUse = Math.min(remainingHours, Math.max(0, hoursAvailableToday));

  //     if (hoursToUse <= 0) {
  //       // nothing can be done today (current at or past end) -> next day
  //       moveToNextWorkingDayStart();
  //       continue;
  //     }

  //     // advance current by hoursToUse
  //     current = new Date(current.getTime() + hoursToUse * 3600000);
  //     remainingHours -= hoursToUse;

  //     if (remainingHours > 0) moveToNextWorkingDayStart();
  //   }

  //   // current is local deadline time; convert to UTC ISO for storage
  //   const deadlineDate = current.toISOString();

  //   return { etaString, deadlineDate };
  // }

  const fetchPriorities = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/tracking/priority/${trackingClientId}`);
      const allProjectsMap = Object.fromEntries(
        allProjects.map((p) => [p.value, p.label]),
      );
      const mappedItems = (res?.data?.data || []).flatMap((item) => {
        const projectName =
          allProjectsMap[item.trackingprojectid] || item.trackingprojectid;
        const trackingprojectid = item.trackingprojectid;
        return (item.prioritydata || []).map((priority) => ({
          ...priority,
          projects: projectName,
          trackingprojectid,
        }));
      });
      dispatch(setAllPriorityData(mappedItems));
    } catch (err) {
      // setError('Failed to fetch priorities');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPriorities();
  }, []);
  // Convert "10:30:00Z" or "2026-01-22T12:30:00Z" (UTC) → local "HH:MM:SS"
  const utcToLocalTimeString = (utcTimeStr) => {
    if (!utcTimeStr) return "";

    let timeStr = utcTimeStr;
    if (utcTimeStr.includes("T")) {
      // Full ISO format: "2026-01-22T12:30:00Z"
      timeStr = utcTimeStr.split("T")[1];
    }
    console.log(utcTimeStr, timeStr, "timeStrtimeStr", typeof timeStr);

    const [hours, minutes, seconds] = timeStr
      .replace("Z", "")
      .split(":")
      .map(Number);

    // Validate parsed values
    if (isNaN(hours) || isNaN(minutes)) {
      console.warn("⚠️ Failed to parse time string:", utcTimeStr);
      return "";
    }

    // Build a full UTC date using today's date + the UTC time
    const now = new Date();
    const utcDate = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        hours,
        minutes,
        seconds || 0,
      ),
    );

    // Extract local HH:MM:SS from that
    const localHours = String(utcDate.getHours()).padStart(2, "0");
    const localMinutes = String(utcDate.getMinutes()).padStart(2, "0");
    const localSeconds = String(utcDate.getSeconds()).padStart(2, "0");

    console.log(localHours, localMinutes, localSeconds, "localcomponents");
    return `${localHours}:${localMinutes}:${localSeconds}`;
  };

  function computeEtaAndDeadlineFromPriority(
    priorityKey,
    project,
    matchedProject,
  ) {
    console.log(
      priorityKey,
      project,
      matchedProject,
      "matchedProjectstarttime",
    );

    // const priorityHoursMap = {
    //   blocker1: 4,
    //   blocker2: 8,
    //   "blocker level 1": 4,
    //   "blocker level 2": 8,
    //   major: 16,
    //   medium: 40,
    //   low: 80,
    // };

    const priorityHoursMap = {
      blocker1: 4,
      blocker2: 8,
      // blocker1: 4,
      // blocker2: 8,
      "blocker level 1": 4,
      "blocker level 2": 8,
      major: 16,
      medium: 40,
      low: 80,
    };
    // const totalHours = priorityHoursMap[priorityKey] || 0;
    // console.log(totalHours, "totalHours");
    // const workStartHour = matchedProject?.starttime;
    // const workEndHour = matchedProject?.endtime;
    // const now = new Date();
    const totalHours = priorityHoursMap[priorityKey?.toLowerCase()] || 0;
    // const workStartHour = `${matchedProject?.starttime}:00`;
    // const workEndHour = `${matchedProject?.endtime}:00`;
    const now = new Date();

    const workStartHour = `${matchedProject?.starttime}:00`
      ? `${matchedProject?.starttime}:00`
      : utcToLocalTimeString(
          matchedProject?.starttime,
        )`${matchedProject?.starttime}:00`;
    const workEndHour = `${matchedProject?.endtime}:00`
      ? `${matchedProject?.endtime}:00`
      : utcToLocalTimeString(matchedProject?.endtime);

    console.log(workEndHour, "hdhddhhd", workStartHour);

    // ✅ Step 1: Validate start & end time
    const hasValidShift =
      typeof workStartHour === "string" &&
      workStartHour.trim() !== "" &&
      typeof workEndHour === "string" &&
      workEndHour.trim() !== "";

    let eta;
    console.log(hasValidShift, "hasValidShifthasValidShift");

    if (hasValidShift) {
      // ✅ Use shift-based calculation
      eta = addWorkHoursConsideringShift(
        now,
        totalHours,
        workStartHour,
        workEndHour,
      );
      console.log(eta, "etaetaetaeta");
    } else {
      // ⚠️ Fallback: Just add straight hours to current time
      console.warn(
        "⚠️ Missing or empty start/end time, using default ETA calculation",
      );
      eta = new Date(now?.getTime() + totalHours * 60 * 60 * 1000);
    }

    // ✅ Validate that eta is a valid Date
    const safeEta = eta instanceof Date && !isNaN(eta) ? eta : new Date();

    return {
      startTime: now?.toISOString(),
      estimatedEndTime: safeEta?.toISOString(),
      totalHours: totalHours,
    };
  }
  let b = computeEtaAndDeadlineFromPriority();
  console.log(b, "bcomputeEtaAndDeadlineFromPriority");
  // function addWorkHoursConsideringShift(
  //   startTime,
  //   workHours,
  //   shiftStartStr,
  //   shiftEndStr,
  // ) {
  //   const safeShiftStart =
  //     typeof shiftStartStr === "string" && shiftStartStr?.trim() !== ""
  //       ? shiftStartStr
  //       : "09:00:00";
  //   const safeShiftEnd =
  //     typeof shiftEndStr === "string" && shiftEndStr?.trim() !== ""
  //       ? shiftEndStr
  //       : "17:00:00";

  //   const [sH, sM, sS] = safeShiftStart.replace("Z", "").split(":").map(Number);
  //   const [eH, eM, eS] = safeShiftEnd.replace("Z", "").split(":").map(Number);

  //   if ([sH, eH].some(isNaN)) {
  //     console.warn("⚠️ Invalid shift hours, using default 9AM–5PM");
  //     return new Date(startTime.getTime() + workHours * 60 * 60 * 1000);
  //   }

  //   const result = new Date(startTime);
  //   let remainingHours = workHours;
  //   console.log(remainingHours, "remainingHoursremainingHours");

  //   while (remainingHours > 0) {
  //     const shiftStart = new Date(result);
  //     shiftStart?.setHours(sH, sM, sS, 0);
  //     const shiftEnd = new Date(result);
  //     shiftEnd?.setHours(eH, eM, eS, 0);
  //     if (shiftEnd <= shiftStart) shiftEnd.setDate(shiftEnd?.getDate() + 1);

  //     const day = shiftStart.getDay();
  //     console.log("holidays-->", holidays);
  //     if (
  //       day === 6 ||
  //       day === 0 ||
  //       holidays?.includes(moment(shiftStart).format("DD-MM-YYYY"))
  //     ) {
  //       const daysToAdd = day === 6 ? 2 : 1;
  //       shiftStart.setDate(shiftStart?.getDate() + daysToAdd);
  //       shiftEnd.setDate(shiftEnd?.getDate() + daysToAdd);
  //       result.setTime(shiftStart?.getTime());
  //       continue;
  //     }

  //     if (result < shiftStart) result?.setTime(shiftStart?.getTime());
  //     if (result >= shiftEnd) {
  //       shiftStart.setDate(shiftStart?.getDate() + 1);
  //       result.setTime(shiftStart?.getTime());
  //       continue;
  //     }

  //     const availableHoursToday = (shiftEnd - result) / (1000 * 60 * 60);
  //     const hoursToAdd = Math.min(availableHoursToday, remainingHours);
  //     result?.setTime(result.getTime() + hoursToAdd * 60 * 60 * 1000);
  //     remainingHours -= hoursToAdd;

  //     if (remainingHours > 0) {
  //       shiftStart?.setDate(shiftStart?.getDate() + 1);
  //       result?.setTime(shiftStart?.getTime());
  //     }
  //   }

  //   console.log("Final ETA result:", result);
  //   return result;
  // }

  function parse12HourTo24(timeStr) {
    if (!timeStr || typeof timeStr !== "string") return null;

    const cleaned = timeStr.trim();

    // Detect AM/PM format: e.g. "08:00 AM", "6:00PM", "08:00:00 AM"
    const ampmMatch = cleaned.match(
      /^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i,
    );
    if (ampmMatch) {
      let h = parseInt(ampmMatch[1], 10);
      const m = parseInt(ampmMatch[2], 10);
      const s = ampmMatch[3] ? parseInt(ampmMatch[3], 10) : 0;
      const period = ampmMatch[4].toUpperCase();

      if (period === "AM") {
        if (h === 12) h = 0; // 12:00 AM → 00:00
      } else {
        if (h !== 12) h += 12; // e.g. 6 PM → 18, but 12 PM stays 12
      }
      return { h, m, s };
    }

    // Fallback: plain 24-hour string "08:00" or "08:00:00"
    const plainMatch = cleaned
      .replace("Z", "")
      .match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (plainMatch) {
      return {
        h: parseInt(plainMatch[1], 10),
        m: parseInt(plainMatch[2], 10),
        s: plainMatch[3] ? parseInt(plainMatch[3], 10) : 0,
      };
    }

    return null;
  }
  function addWorkHoursConsideringShift(
    startTime,
    workHours,
    shiftStartStr,
    shiftEndStr,
  ) {
    console.log("🚀 FUNCTION START");
    console.log(
      "Starthdhsjhdjs",
      startTime,
      "Starthdhsjhdjs",
      workHours,
      "Starthdhsjhdjs",
      shiftStartStr,
      "Starthdhsjhdjs",
      shiftEndStr,
    );

    const startParsed = parse12HourTo24(shiftStartStr) || { h: 9, m: 0, s: 0 };
    const endParsed = parse12HourTo24(shiftEndStr) || { h: 17, m: 0, s: 0 };

    const { h: sH, m: sM, s: sS } = startParsed;
    const { h: eH, m: eM, s: eS } = endParsed;

    console.log(`🕒 Parsed Shift: ${sH}:${sM}:${sS} → ${eH}:${eM}:${eS}`);

    if (isNaN(sH) || isNaN(eH)) {
      console.warn("⚠️ Invalid shift hours, fallback applied");
      const fallback = new Date(
        startTime.getTime() + workHours * 60 * 60 * 1000,
      );
      console.log("Fallback Result:", fallback);
      return fallback;
    }

    const result = new Date(startTime);
    let remainingHours = workHours;

    console.log("📍 Initial Result:", result);

    while (remainingHours > 0) {
      console.log("🔁 LOOP START");
      console.log("Current Result Time:", result);
      console.log("Remaining Hours:", remainingHours);

      const shiftStart = new Date(result);
      shiftStart.setHours(sH, sM, sS, 0);

      const shiftEnd = new Date(result);
      shiftEnd.setHours(eH, eM, eS, 0);

      if (shiftEnd <= shiftStart) {
        shiftEnd.setDate(shiftEnd.getDate() + 1);
        console.log(
          "🌙 Overnight shift detected, adjusted shiftEnd:",
          shiftEnd,
        );
      }

      console.log(shiftStart, "ShiftStartTime:", shiftEnd);
      console.log("Shift End Time:", shiftEnd);

      const day = result.getDay();
      console.log("📅 Day of week:", day);

      if (day === 6 || day === 0) {
        const daysToAdd = day === 6 ? 2 : 1;
        console.log("⛔ Weekend detected, skipping days:", daysToAdd);

        result.setDate(result.getDate() + daysToAdd);
        result.setHours(sH, sM, sS, 0);

        console.log("➡️ Moved to next working day:", result);
        continue;
      }

      if (result < shiftStart) {
        console.log("⏩ Before shift start, jumping to shift start");
        result.setTime(shiftStart.getTime());
      }

      if (result >= shiftEnd) {
        console.log("⏭️ After shift end, moving to next day");

        result.setDate(result.getDate() + 1);
        result.setHours(sH, sM, sS, 0);

        console.log("➡️ Next day start:", result);
        continue;
      }

      const availableHoursToday = (shiftEnd - result) / (1000 * 60 * 60);
      console.log("⏳ Available Hours Today:", availableHoursToday);

      const hoursToAdd = Math.min(availableHoursToday, remainingHours);
      console.log("➕ Hours to Add Now:", hoursToAdd);

      result.setTime(result.getTime() + hoursToAdd * 60 * 60 * 1000);
      remainingHours -= hoursToAdd;

      console.log("🆕 Updated Result:", result);
      console.log("📉 Remaining Hours After Deduction:", remainingHours);

      if (remainingHours > 0) {
        console.log("➡️ Moving to next working day");

        result.setDate(result.getDate() + 1);
        result.setHours(sH, sM, sS, 0);

        console.log("📍 Next Day Start:", result);
      }
    }

    console.log("🏁 FINAL ETA:", result);
    console.log("✅ FUNCTION END");

    return result;
  }

  console.log(inputvalue, "inputvalue11");
  const SubmitForm = async (form, valid, setEditorState) => {
    console.log(form, "formformform");
    const project = findProjectFromForm(form);

    const matchedProject = allprojectsnew.find(
      (p) => p.label === project?.projectName,
    );
    const priorityKey = normalizePriorityKey(
      form?.priority ?? formvalue?.priority,
    );
    console.log(form?.priority, "newvafdsjkhdsndmsndms", priorityKey);

    // const { etaString, deadlineDate } = computeEtaAndDeadlineFromPriority(
    //   priorityKey,
    //   matchedProject,
    //   matchedProject.starttime?.slice(0, 5), // "18:30:00Z" → "18:30"
    //   matchedProject.endtime?.slice(0, 5)    // "13:37:00Z" → "13:37"
    // );
    // console.log(priorityKey, "priorityKey");
    console.log(form, "formformform", form.deadline);
    let values = computeEtaAndDeadlineFromPriority(
      priorityKey,
      project,
      matchedProject,
    );
    console.log(values, "bddsdks");

    const deadline =
      form?.deadlineType === "Yes"
        ? form.deadline
        : computeEtaAndDeadlineFromPriority(
            priorityKey,
            project,
            matchedProject,
          );

    //   inputvalue?.deadline === "Yes" ? form.deadline : form.deadline;
    // console.log(deadline, "deadlinedeadline");

    // console.log("ETA:", etaString);
    // console.log("Deadline:", deadlineDate);

    if (deadline) {
      setFormvalue((prev) => ({
        ...prev,
        eta: deadline?.totalHours || prev.eta,
        // deadline: deadline?.estimatedEndTime || prev.deadline, // :white_check_mark: direct UTC string
      }));
    }
    console.log(valid, "isavalid");
    if (valid) {
      // setLoading(true);
      const updatedFile = await handleTUDFileUpload(
        trackingClientId,
        form.project_name.id,
      );
      const value = updatedFile?.map((item) => ({
        testcasedocumentid: item.id,
        filename: item.name,
        subname: item?.subname,
      }));
      console.log(valuefordeadline, "formmmmmmm");
      let Obj = {
        deadlineType: form?.deadlineType || "",
        title: form.title,
        trackingprojectsid: form.project_name.id,
        type: form.tasktype.id,
        priority:
          form.priority === "blocker1"
            ? "blocker level 1"
            : form.priority === "blocker2"
              ? "blocker level 2"
              : form.priority || "",
        backlogs: form.backlogs,
        fileurls: fileNameList,
        description: form.description,
        reportedby: user.trackinguserid,
        assignedto: form.assignedto.id,
        timezone: timezone,
        referencenumber: form?.referencenumber ?? "",
        startdateandtime: form.startdateandtime,
        enddateandtime: form.enddateandtime,
        label: form?.label ?? "",
        authorizationToken: authToken,
        filesize: fileSize,
        eta: form?.eta ? `${form.eta}` : "",
        deadline:
          form?.deadlineType === "Yes" && deadline
            ? moment(deadline).format("DD-MM-YYYY HH:mm")
            : valuefordeadline ||
              (deadline?.estimatedEndTime
                ? moment(deadline.estimatedEndTime).format("DD-MM-YYYY HH:mm")
                : ""),
        originaldeadline:
          form?.deadlineType === "Yes" && deadline
            ? moment(deadline).toISOString()
            : deadline?.estimatedEndTime || "",
        originalsla: "",
        istaskapproval: matchedProject?.istaskapproval,
        action: "",
        approvalaction: "",
        tudDocument: [],
        testCaseDocument: value || [],
      };
      console.log(Obj, "ObjObj");
      api
        .post("/tracking/" + trackingClientId, Obj, {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        })
        .then(function (response) {
          if (response.status === 200 && response.data && response.data.data) {
            dispatch(setShowAlert(true));
            setSubmitted(true);
            let item = {
              trackingid: response.data.data.trackingid,
              trackingclientid: response.data.data.trackingclientid,
              trackingprojectsid: response.data.data.trackingprojectsid,
              comments: response.data.data.comments,
              history: response.data.data.history,
              description: response.data.data.description,
              priority: response.data.data.priority,
              fileurls: response.data.data.fileurls,
              title: response.data.data.title,
              type: response.data.data.type,
              trackingprojectstatusid:
                response.data.data.trackingprojectstatusid,
              assignedto: response.data.data.assignedto,
              reportedby: user.trackinguserid,
              reporteddate: response.data.data.reporteddate,
              referencenumber: response.data.data.referencenumber,
              lable: response.data.data.lable,
              projectmodel: response.data.data.projectmodel,
              tasktype: response.data.data.tasktype,
              eta: response.data.data.eta
                ? `${response.data.data.eta} hrs`
                : "",
              deadline: response.data.data.deadline,

              tudfile:
                response.data.data?.tuddocument?.map((tud) => tud?.name) || [],
              testcasefile:
                response?.data?.data?.testCaseDocument?.map(
                  (tcd) => tcd?.name,
                ) || [],
            };
            const trackingid = response.data.data.trackingid;

            const approvalStatus = response.data.data.approval_status;

            if (form.backlogs === "Yes") {
              if (!form.add_task) {
                setTaskview("AllTask");
              }
              setShowAlertBox(true);
              setAlertMessage(
                "(" +
                  trackingClientId +
                  "-" +
                  response.data.data.trackingid +
                  (approvalStatus === ""
                    ? ") New Backlogs item has been created successfully" //? if approvalStatus is "" it is not for hashching users
                    : ") New Backlogs items has been created and waiting for Approval"),
              );
              setResetEditorValue(true);
            } else {
              if (
                response.data.data.assignedto === user.trackinguserid &&
                approvalStatus === ""
              ) {
                myTrackingList.push(item);
              }
              dispatch(setMyTrackings([...myTrackingList]));
              if (approvalStatus === "") {
                allTrackingsList.push(item);
              }
              dispatch(setAllTrackings([...allTrackingsList]));

              handleFileUpload(trackingid);

              setLoading(false);
              if (!form.add_task) {
                setTaskview("AllTask");
              }
              setShowAlertBox(true);
              setAlertMessage(
                "(" +
                  trackingClientId +
                  "-" +
                  response.data.data.trackingid +
                  (approvalStatus === ""
                    ? ") New tracking item has been created successfully" //? if approvalStatus is "" it is not for hashching users
                    : ") New Tracking items has been created and waiting for Approval"),
              );
              setResetEditorValue(true);
            }
          } else {
            setLoading(false);
          }
        })
        .catch(function (error) {
          setLoading(false);
          setShowAlertBox(true);
          setAlertMessage("Failed to create task. Please try again.");
        });
    } else {
    }
  };

  const handleFileUpload = async (trackingid) => {
    for (let i = 0; i < fileArr.length; i++) {
      try {
        const base64file = await fileToBase64(fileArr[i]);

        const response = await api.post(
          "/tracking/fileupload",
          {
            trackingid: trackingid,
            trackingclientid: trackingClientId,
            fileurls: fileArr[i].name,
            fileType: fileArr[i].type,
            filedata: base64file,
          },
          {
            headers: {
              authorizationtoken: ` ${authToken}`,
            },
          },
        );
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleTUDFileUpload = async (ClientId, projectid) => {
    const updatedFile = tudfileArr.map((file, index) => ({
      file: file,
      id: new Date().getTime() + index,
      name: file.name,
      type: file.type,
      subname: "TCD-" + projectid + "-" + moment().format("DD-MM-YYYY HH:mm"),
    }));
    try {
      if (!updatedFile.length) return;

      const uploadPromises = updatedFile.map(async (fileData) => {
        const response = await api.post(
          `/tracking/document/${trackingClientId}?method=upload`,
          {
            tcddocumentid: fileData.id,
            filename: fileData.name,
            name: "testcasefile",
          },
          { headers: { authorizationtoken: `${authToken}` } },
        );

        const URL = response.data?.data;
        await fetch(URL, {
          method: "PUT",
          headers: {
            "Content-Type": fileData.type || "application/octet-stream",
          },
          body: fileData.file,
        });
      });

      await Promise.all(uploadPromises);
      return updatedFile;
    } catch (error) {
      console.error("Error uploading TUD file:", error);
      throw error;
    }
  };

  const onCancelHandle = (response) => {
    if (response) setCancelConfirmationShow(true);
    else setTaskview("AllTask");
  };

  const cancelConfimrationHandler = (response) => {
    if (response) setTaskview("AllTask");
  };

  return (
    <>
      <TrackingFormWrap>
        <h4 className="d-flex justify-content-start align-items-center mb-1">
          <ArrowCircleLeftIcon
            className="me-3"
            onClick={() => {
              setTaskview("AllTask");
            }}
            style={{ cursor: "pointer", color: "#4EB6EE", fontSize: "30px" }}
          />
          <div className="title add-new-task">Add new task</div>
        </h4>

        <div className="formbody flex justify-center items-center h-screen w-full">
          {formLoading ? (
            <BarLoader
              color="#4eb6ee"
              width={250} // make it longer
              height={12} // make it thicker
              aria-label="Loading..."
            />
          ) : (
            <Forms
              title={""}
              className="p-2"
              // key={inputvalue?.priority || "default"}
              formArr={
                inputFormArr ? filteredInputFormArr : filteredAllAddTaskInputs
              }
              template="template"
              setTaskview={setTaskview}
              formvalue={formvalue}
              FileName={setFileNameLIst}
              FileArr={setFileArr}
              submitBtn={"Create"}
              cancelBtn={true}
              buttonclr={"#3E3F3E"}
              setInputvalue={setInputvalue}
              // inputvalue={inputvalue}
              onChange={(val) => {
                setFormvalue((prev) => ({
                  ...prev,
                  ...val,
                  priority:
                    val.priority !== undefined ? val.priority : prev.priority,
                }));
              }}
              onSubmit={SubmitForm}
              onResetEditor={resetEditorValue}
              onCancel={onCancelHandle}
              showcheckbox={true}
              loading={loading}
              submitted={submitted}
              changeInForm={changeInForm}
              setChangeInForm={setChangeInForm}
              editorRef={editorRef}
              getAllMembers={getAllMembers}
              getAllProjects={getAllProjects}
              allProjects={allProjects}
              allprojectsnew={allprojectsnew}
              allMembers={result}
              customPriorityOptions={customPriorityOptions}
              setFileSize={setFileSize}
              setFormvalue={setFormvalue}
              newtask={true}
              startdateandtime={formvalue?.startdateandtime}
              enddateandtime={formvalue?.enddateandtime}
              taskTypeOptions={taskTypeOptions}
              setTudFileArr={setTudFileArr}
              formsType={"AddTask"}
            />
          )}
        </div>
        <ConfirmationBox
          heading={"You may loss your changes. Are you sure to cancel"}
          hidePopup={(e) => setCancelConfirmationShow(false)}
          show={cancelConfirmationShow}
          confirmationResponse={cancelConfimrationHandler}
        />
      </TrackingFormWrap>
    </>
  );
};
